import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactTabulator } from 'react-tabulator';
import 'tabulator-tables/dist/css/tabulator.min.css';
import BlankPageTemplate from '../Templates/BlankPageTemplate';
import ContainerFluid from '../ThemeComponents/grid/ContainerFluid';
import Row from '../ThemeComponents/grid/Row';
import Col from '../ThemeComponents/grid/Col';
import { locationsMock } from '../mock/locations-mock';

const dayOrder = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
const dayLabels = {
  mon: 'Mon',
  tue: 'Tue',
  wed: 'Wed',
  thu: 'Thu',
  fri: 'Fri',
  sat: 'Sat',
  sun: 'Sun',
};

const formatSchedule = (schedule, isAlwaysOpen) => {
  if (isAlwaysOpen) {
    return '24/7';
  }

  if (!schedule) {
    return '-';
  }

  return dayOrder
    .map((day) => {
      const entry = schedule[day];
      if (!entry) {
        return `${dayLabels[day]}: -`;
      }
      return `${dayLabels[day]} ${entry.from}-${entry.to}`;
    })
    .join(', ');
};

const tableData = locationsMock.map((location) => ({
  ...location,
  scheduleSummary: formatSchedule(location.schedule, location.isAlwaysOpen),
}));

const buildColumns = (navigate) => [
  { title: 'ID', field: 'id', sorter: 'number', headerFilter: 'input', width: 80 },
  { title: 'Name', field: 'name', sorter: 'string', headerFilter: 'input', minWidth: 200 },
  { title: 'Promo', field: 'locationPromo', sorter: 'string', headerFilter: 'input' },
  {
    title: 'Vehicles',
    field: 'amountOfVehicles',
    sorter: 'number',
    headerFilter: 'input',
    hozAlign: 'right',
  },
  {
    title: 'Always Open',
    field: 'isAlwaysOpen',
    sorter: 'boolean',
    headerFilter: 'input',
    formatter: (cell) => (cell.getValue() ? 'Yes' : 'No'),
  },
  {
    title: 'Schedule',
    field: 'scheduleSummary',
    sorter: 'string',
    headerFilter: 'input',
    widthGrow: 2,
  },
  {
    title: 'Actions',
    field: 'actions',
    headerSort: false,
    hozAlign: 'right',
    headerHozAlign: 'right',
    width: 180,
    formatter: () =>
      '<div class="d-flex gap-2 justify-content-end">' +
      '<button type="button" class="btn btn-sm btn-primary" data-action="edit">Edit</button>' +
      '<button type="button" class="btn btn-sm btn-danger" data-action="delete">Delete</button>' +
      '</div>',
    cellClick: (event, cell) => {
      const action = event.target?.dataset?.action;
      if (!action) {
        return;
      }
      const { id } = cell.getRow().getData();
      if (action === 'edit') {
        navigate(`/backoffice/locetions/${id}`);
      }
    },
  },
];

const Locations = () => {
  const navigate = useNavigate();
  const columns = buildColumns(navigate);

  return (
    <BlankPageTemplate title="Locations">
      <ContainerFluid>
        <Row>
          <Col cols="col-12">
            <ReactTabulator
              data={tableData}
              columns={columns}
              options={{ layout: 'fitColumns', placeholder: 'No locations yet' }}
            />
          </Col>
        </Row>
      </ContainerFluid>
    </BlankPageTemplate>
  );
};

export default Locations;
